import { render, staticRenderFns } from "./WaterMarksFramesSelector.vue?vue&type=template&id=6c4da0c0&scoped=true&"
import script from "./WaterMarksFramesSelector.vue?vue&type=script&lang=js&"
export * from "./WaterMarksFramesSelector.vue?vue&type=script&lang=js&"
import style0 from "./WaterMarksFramesSelector.vue?vue&type=style&index=0&id=6c4da0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4da0c0",
  null
  
)

export default component.exports